export const DOCUMENT_STATE = {
  ADDED: "ADDED",
  APPLIED: "APPLIED",
  CORRECTED: "CORRECTED",
  FAILED: "FAILED",
  IGNORED: "IGNORED",
  PARSED: "PARSED",
};
